import { render, staticRenderFns } from "./AppointmentAuditDetail.vue?vue&type=template&id=3846fb7a&scoped=true"
import script from "./AppointmentAuditDetail.vue?vue&type=script&lang=js"
export * from "./AppointmentAuditDetail.vue?vue&type=script&lang=js"
import style0 from "./AppointmentAuditDetail.vue?vue&type=style&index=0&id=3846fb7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3846fb7a",
  null
  
)

export default component.exports